<template>
  <a
    @click.prevent="$emit('click', !active)"
    class="waves-effect waves-light btn btn-icon secondary-content--disabled"
    :class="{ active }"
  >
    <feather :type="active ? 'toggle-right' : 'toggle-left'" size="24" />
  </a>
</template>

<script>
export default {
  name: "DisabledItemButton",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.waves-effect.waves-light.btn.btn-icon.secondary-content--disabled.active {
  padding: 0;
  background-color: #2fad34;
  &:hover {
    background-color: #3ec743 !important;
  }
}
.waves-effect.waves-light.btn.btn-icon.secondary-content--disabled {
  min-width: 36px;
  min-height: 36px;
  padding: 0;
  background-color: #e12929;
  &:hover {
    background-color: #ff7f7f !important;
  }
}
</style>
